import type { ProposalDetails } from '@/services/quotes/types';

export type EntityRisk = NonNullable<
  NonNullable<NonNullable<ProposalDetails['lobs']>[0]['risks']>[0]
> & {
  riskName?: string;
  memberCount?: number;
  individualCapital?: number;
  groupProfile?: string;
};

export type ResolvedEntityRisks = {
  profile: 'ESCALONADO' | 'UNIFORME';
  uniform?: EntityRisk;
  partners?: EntityRisk;
  employees?: EntityRisk;
};

const MEMBER_CATEGORY_PARTNERS = '2';
const MEMBER_CATEGORY_EMPLOYEES = '1';

export function buildRiskName(sequenceNumber: number, groupCode?: string): string {
  return groupCode !== undefined
    ? `profile-${sequenceNumber}-${groupCode}`
    : `profile-${sequenceNumber}`;
}

export function parseSequenceFromRiskName(riskName: unknown): number | undefined {
  if (typeof riskName !== 'string') return undefined;
  const match = riskName.match(/^profile-(\d+)(-\d+)?$/);
  return match ? Number(match[1]) : undefined;
}

export function hasRiskMembers(risk: EntityRisk | undefined): boolean {
  return (risk?.memberCount ?? 0) > 0;
}

/**
 * Resolve risco(s) de um estipulante/subestipulante pelo `RiskName` e
 * `sequenceNumber` (mesma regra do PDF — Fase 1).
 */
export function resolveRisksForCustomer(
  sequenceNumber: number,
  risks: EntityRisk[],
): ResolvedEntityRisks {
  const customerRisks = risks.filter(
    r => parseSequenceFromRiskName(r.riskName) === sequenceNumber,
  );

  const partners = customerRisks.find(
    r => r.riskName === buildRiskName(sequenceNumber, MEMBER_CATEGORY_PARTNERS),
  );
  const employees = customerRisks.find(
    r => r.riskName === buildRiskName(sequenceNumber, MEMBER_CATEGORY_EMPLOYEES),
  );

  if (partners || employees) {
    return { profile: 'ESCALONADO', partners, employees };
  }

  const uniform = customerRisks.find(
    r => r.riskName === buildRiskName(sequenceNumber),
  );
  return { profile: 'UNIFORME', uniform };
}
